/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';

interface AircraftTailTagProps {
  terminalNum: number; // The terminal number on the aircraft 1 to n or undefined if only 1 terminal
  datapathUuid: string;
}

/**
 * This class represents the styling and DOM for the aircraft tail tag on google maps.
 */
const AircraftTailTagLinkway = (props: AircraftTailTagProps): React.ReactComponentElement<'div', {}> => {
  const { terminalNum, datapathUuid } = props;

  return (
    <div className={`map__tailtag--detailcontainer map__tailtag--detailcontainer${terminalNum}`}>
      <div className={`map__tailtag--row map__tailtag--row${terminalNum}`}>
        <div
          data-test={`map__tailtag-${datapathUuid}--lw_network--idx-${terminalNum}`}
          className={`map__tailtag--lw_network map__tailtag--lw_network${terminalNum}`}
        />
      </div>
      <div className={`map__tailtag--row map__tailtag--row${terminalNum}`}>
        <div
          data-test={`map__tailtag-${datapathUuid}--lw_tx_power-${terminalNum}`}
          className={`map__tailtag--lw_tx_power map__tailtag--lw_tx_power${terminalNum}`}
        />
      </div>
      <div className={`map__tailtag--row map__tailtag--row${terminalNum}`}>
        <div
          data-test={`map__tailtag-${datapathUuid}--lw_site_id-${terminalNum}`}
          className={`map__tailtag--lw_site_id map__tailtag--lw_site_id${terminalNum}`}
        />
      </div>
    </div>
  );
};

export default AircraftTailTagLinkway;
